export enum CampaignOfferType {
    LONG_TERM = 'long_term',
    LINKED = 'linked',
    ADDONS = 'addons_only',
    ON_TOP = 'on_top',
};